import React , {useState ,useEffect} from "react";
import Card from "@mui/material/Card";
import Link from "@mui/material/Link";
import Carousel from "react-material-ui-carousel";
import { useTranslation } from "react-i18next";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardMedia from "@mui/material/CardMedia";
import { useTheme } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBalanceScaleRight } from "@fortawesome/free-solid-svg-icons";
import { useHistory, useParams } from "react-router-dom";
import { faHeart, faBell } from '@fortawesome/free-solid-svg-icons'
import { faHeart as faHeartNotFilled , faBell as faBellNotFilled ,  } from '@fortawesome/free-regular-svg-icons'
import { useDispatch, useSelector } from "react-redux";
import useMediaQuery from '@mui/material/useMediaQuery';
import moment from "moment";
const ProductCard = ({ card, handleChange,showNotificationsIcon}) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const xsDown = useMediaQuery(theme.breakpoints.up('xs'));
  const [priceAfterDiscount ,setPriceAfterDiscount]=useState(
    card?.discount && Number(card?.discount) > 0
      ? card.price - card.price * (Number(card?.discount) / 100)
      : undefined);
  const history = useHistory();
  const userFavProducts = useSelector(
    (state) => state.favouriteProducts.products
  );
  const userNotficationsProducts = useSelector(
    (state) => state.notificationsProducts.notificationsProducts
  );
  const [isActive, setActive] = useState(card?.id ?showNotificationsIcon ? userNotficationsProducts?.includes(card.id):  userFavProducts?.includes(card.id):false);
  useEffect(()=>{
    if (card.currentDiscountExpiry && card.currentDiscountExpiry != null) {
        const exp = card.currentDiscountExpiry;
       const isValid = moment(new Date()).isSameOrBefore(exp);
        const diff = moment().diff(exp, 'days');
        
        console.log("titile : ",card.titleEn);
        console.log("isAfter : ",isValid);
        console.log("diff : ",diff);
        console.log("exp : ",exp);
        if(isValid &&(diff*-1)<=10){
            if (card.discount && Number(card.discount) > 0) {
                
                setPriceAfterDiscount( card.price - (card.price * (Number(card.discount) / 100)));
    
            }
        }
        if(!isValid){
            setPriceAfterDiscount(undefined);
        }
      }
},[card])
  return (
    <Grid  item key={card?.id} xs={12} sm={4} md={4} style={{minHeight:"-webkit-fill-available"}}>
      <Card
      style={{height:xsDown ? "80%" :""}}
        elevation={3}
        onClick={() => !handleChange ? history.push("/product/" + card.id) :""}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        {card.images && card.images.length > 0 && (
          <Carousel
            navButtonsAlwaysVisible={true}
            autoPlay={false}
            activeIndicatorIconButtonProps={{
              style: {
                backgroundColor: theme.light.primary,
                color: theme.light.primary,
              },
            }}
            swipe={true}
            navButtonsProps={{
              style: {
                backgroundColor: theme.light.primary,
              },
            }}
          >
            {card.images.map((item, i) => (
              <CardMedia
              onClick={() =>  handleChange ? history.push("/product/" + card.id) :""}
              key={"product image home page " + i}
                component="img"
                style={{
                  width: '100%',
                  alignSelf: 'center',
                  height: "300px",
                  objectFit: !xsDown ?  "cover" : "contain",
                }}
                sx={
                  {
                    // 16:9
                    //pt: '56.25%',
                  }
                }
                image={item}
                alt="random"
              />
            ))}
          </Carousel>
        )}

        <CardContent sx={{ flexGrow: 1 }}  style={{ display: handleChange ? "flex" : "", flexDirection: handleChange ? "row" : "", justifyContent: handleChange ? "space-between" : "" }}>
          <Typography gutterBottom variant="h5" component="h2" align= {!handleChange ? "center" :""}>
            {card[i18n.language == "ar" ? "titleAr" : "titleEn"]}
          </Typography>
          {handleChange &&
            <div onClick={() => { handleChange(card.id);setActive(!isActive) }} style={{
              marginTop: -30,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              alignSelf: "flex-end",
              flexDirection: "row",
              cursor: "pointer",
              paddingTop: 8,
              height: 50, width: 50,
            }}>
             {!showNotificationsIcon ? <FontAwesomeIcon
                icon={isActive ? faHeart : faHeartNotFilled}
                style={{ fontSize: 35, color: theme.light.primary }}
              />:  <FontAwesomeIcon
                icon={isActive ? faBell : faBellNotFilled}
                style={{ fontSize: 35, color: theme.light.primary }}
              />}
            </div>}
        </CardContent>
        <CardActions
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          {card.storeInfo && (
            <div
              style={{
                marginTop: 8,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginLeft: 5,
                marginBottom: 5,
              }}
            >
              {!!card.storeInfo.image && card.storeInfo.image != "" && (
                <img
                  src={card.storeInfo.image}
                  style={{
                    width: 60,
                    height: 60,
                    resizeMode: "contain",
                    marginVertical: 2,
                  }}
                />
              )}
            </div>
          )}
          <div
            style={{
              marginTop: 8,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <FontAwesomeIcon
              fontSize={30}
              color={theme.light.dark}
              icon={faBalanceScaleRight}
            />
          </div>
          {!!card.price && (
            <div
              style={{
                marginTop: 8,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                marginRight: 5,
              }}
            >
              <div
                style={{
                  marginTop: 10,
                  justifyContent: "flex-end",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {!priceAfterDiscount  && ( <Typography
                  gutterBottom
                  variant="body2"
                  style={{ color: "green", fontWeight: "bold", fontSize: 17 }}
                >{`${new Number(card.price).toFixed(2)} ${t(
                  "product.currency"
                )}`}</Typography>)}
                {priceAfterDiscount && priceAfterDiscount > 0 && ( <Typography
                  gutterBottom
                  variant="body2"
                  style={{ color: "green", fontWeight: "bold", fontSize: 17 }}
                >{`${priceAfterDiscount.toFixed(2)} ${t(
                  "product.currency"
                )}`}</Typography>)}
               
               {priceAfterDiscount && priceAfterDiscount > 0 && (  <Typography
                    gutterBottom
                    variant="body2"
                    style={{
                      color: "#222",
                      color: "red",
                      fontWeight: "bold",

                      marginLeft: 10,
                      textDecorationLine: "line-through",
                      fontSize: 13,
                    }}
                  >{`${new Number(card.price).toFixed(2)} ${t(
                    "product.currency"
                  )}`}</Typography>)}
                
              </div>
            </div>
          )}
        </CardActions>
      </Card>
    </Grid>
  );
};

export default ProductCard;
